module.exports = __webpack_public_path__ + "media/img/testimonial/jonathanpang_distrii-7de77ac278875bee55b395c0b668e09c.png";